import styled from 'styled-components';

interface WeatherButtonProps {
  $hasError?: boolean;
  hideOn?: 'mobile' | 'desktop';
}

export const WeatherButton = styled.button<WeatherButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0 15px;
  height: 100%;
  transition: transform 0.2s ease;
  outline: none;

  ${props =>
    props.hideOn === 'mobile' &&
    `
    @media (max-width: 1024px) {
      display: none !important;
    }
  `}

  ${props =>
    props.hideOn === 'desktop' &&
    `
    @media (min-width: 1025px) {
      display: none !important;
    }
  `}

  &:hover {
    transform: scale(1.05);
  }

  ${props =>
    props.$hasError &&
    `
    border: 1px solid red;
    border-radius: 8px;
  `}
`;

export const WeatherIcon = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;

  @media (max-width: 1024px) {
    width: 45px;
    height: 45px;
  }
`;

export const WeatherInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
  line-height: 1;
`;

export const TemperatureText = styled.span`
  font-size: 2em;
  font-weight: 900;
  color: #333;

  @media (max-width: 1024px) {
    font-size: 1.4em;
  }
`;

export const DescriptionText = styled.span`
  font-size: 1em;
  font-weight: 500;
  color: #666;
  text-transform: lowercase;
  margin-top: -2px;

  @media (max-width: 1024px) {
    font-size: 0.8em;
  }
`;
